import trackState from "@/stores/clip/trackState";
import { Button } from "@arco-design/web-react";
import { IconDelete } from "@arco-design/web-react/icon";
import MenuItem from "./MenuItem";
import { useEffect, useRef, useState } from "react";
import "./index.less";

const Menu = () => {
  const menuEl = useRef<HTMLDivElement>(null);
  const listEl = useRef<HTMLDivElement>(null);
  const [isCenter, setIsCenter] = useState(true);

  useEffect(() => {
    const observer = new ResizeObserver((entries) => {
      for (const entry of entries) {
        const { width, height } = entry.contentRect;
        console.log("尺寸变化:", width, height);
        // 在这里处理尺寸变化逻辑
        setIsCenter(height + 30 > listEl.current?.clientHeight);
      }
    });

    if (menuEl.current) {
      observer.observe(menuEl.current);
    }

    return () => {
      if (menuEl.current) {
        observer.unobserve(menuEl.current);
      }
    };
  }, []);

  useEffect(() => {
    menuEl.current.scrollTop = trackState.scrollData.scrollTop;
  }, [trackState.scrollData.scrollTop]);
  return (
    <div
      ref={menuEl}
      id="track-menu"
      className="track-menu hide-scrollbar"
      style={{
        position: "relative",
        padding: "30px 6px 0",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: isCenter ? "center" : "flex-start",
        boxSizing: "border-box",
        width: 128,
        height: trackState.scrollData.scrollX ? "calc(100% - 8px)" : "100%", // 有横向滚动时，要减去滚动条高度
        overflowY: "hidden",
      }}
    >
      <div
        ref={listEl}
        style={{
          width: "100%",
          // transform: `translate(0, -${trackState.scrollData.scrollTop}px)`,
        }}
      >
        {trackState.trackList.map((item, index) => {
          return <MenuItem item={item} key={index} />;
        })}
      </div>
    </div>
  );
};

export default Menu;
